import React, { useState } from 'react';
import { properties } from '../../properties';
import Response from '../Response';
import LoaderComp from '../LoaderComp';

function Probe({apiUrl}) {
    const [response, setResponse] = useState();

    const [probe] = useState({
        operation: properties.OPERATIONS.probe,
        method: properties.HTTP_METHOD
    });

    var requestBody = {
        WPG_operation: probe.operation,
        WPG_method: probe.method
    }
    var formBody = [];
    for (var property in requestBody) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(requestBody[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    var request = {
        method: "POST",
        headers: new Headers({
            "Content-Type":"application/x-www-form-urlencoded"
        }),
        body: formBody
    }

    function submitProbe(){
        document.getElementsByClassName("loader")[0].classList.add("loading");
        fetch(apiUrl, request, true)
        .then(response => {
            if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(response.status)) === -1){
                return response.text();
            }
            else{
                return properties.WPS_OFFLINE_MESSAGE;
            }
        })
        .then(responsetext => setResponse(<Response title="Probe Response" message={responsetext}/>))
        .catch((error)=>{
            console.log(error);
            setResponse(<Response title="Probe Response" message={properties.WPS_OFFLINE_MESSAGE}/>);
        });
    }

    var probeTemplate = (
        <div>
            <div className="operation-form">
                <h2>Probe</h2>
                <p>Check server available.</p>
                <div className="col-sm-5">
                    <button className="btn btn-primary" onClick={submitProbe}>Perform</button>
                </div>
            </div>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
        );

    return response?response:probeTemplate;
}

export default Probe;